/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetProductFeatureRequestBody,
  SetProductFeatureRequestBody$Outbound,
  SetProductFeatureRequestBody$outboundSchema,
} from "../components/setproductfeaturerequestbody.js";

export type SetProductFeatureSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetProductFeatureRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setProductFeatureRequestBody: SetProductFeatureRequestBody;
};

/** @internal */
export type SetProductFeatureSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetProductFeatureSecurity$outboundSchema: z.ZodMiniType<
  SetProductFeatureSecurity$Outbound,
  SetProductFeatureSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setProductFeatureSecurityToJSON(
  setProductFeatureSecurity: SetProductFeatureSecurity,
): string {
  return JSON.stringify(
    SetProductFeatureSecurity$outboundSchema.parse(setProductFeatureSecurity),
  );
}

/** @internal */
export type SetProductFeatureRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SetProductFeatureRequestBody: SetProductFeatureRequestBody$Outbound;
};

/** @internal */
export const SetProductFeatureRequest$outboundSchema: z.ZodMiniType<
  SetProductFeatureRequest$Outbound,
  SetProductFeatureRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    setProductFeatureRequestBody: SetProductFeatureRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      setProductFeatureRequestBody: "SetProductFeatureRequestBody",
    });
  }),
);

export function setProductFeatureRequestToJSON(
  setProductFeatureRequest: SetProductFeatureRequest,
): string {
  return JSON.stringify(
    SetProductFeatureRequest$outboundSchema.parse(setProductFeatureRequest),
  );
}
